import { NotificationsPopover } from "./NotificationsPopover";

export const Notifications = () => <NotificationsPopover />;
